import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { Box, HStack } from "@chakra-ui/react";
import { User } from "lucide-react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { contractStatusLabels } from "../columns";
import { Contract, ContractFilters } from "../types";

const statusByLabel = Object.fromEntries(
  Object.entries(contractStatusLabels).map(([status, label]) => [label, status])
) as Record<string, Contract["status"]>;

type Props = {
  queryFilters: ContractFilters;
  setQueryFilters: Dispatch<SetStateAction<ContractFilters>>;
};

const Filters = ({ queryFilters, setQueryFilters }: Props): JSX.Element => {
  const handleSearchByDocument = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, tenantDocumentNumber: value })),
    [setQueryFilters]
  );

  return (
    <Box display="flex" gap="1rem">
      <HStack flexGrow={1} position="relative">
        <Box position="absolute" right={3} zIndex={1}>
          <User size={18} color="#9F9DB0" />
        </Box>
        <DebouncedInput
          size="sm"
          placeholder="Buscar por documento"
          _placeholder={{ color: "#5D5C60" }}
          value={queryFilters.tenantDocumentNumber}
          onDebouncedChange={handleSearchByDocument}
        />
      </HStack>
      <SelectFilter
        options={Object.values(contractStatusLabels)}
        selectedOption={
          queryFilters.status && contractStatusLabels[queryFilters.status]
        }
        onSelect={(label) =>
          setQueryFilters((prev) => ({
            ...prev,
            status: label ? statusByLabel[label] : undefined,
          }))
        }
        placeholder="Vigentes"
        width="25%"
      />
    </Box>
  );
};

export default Filters;
